import { ExtendedAddress, OrderListTableField } from 'cloud-shared-lib';

import { CuttingEngine } from '../user/cutting-settings.model';
import { CuttingClientGroup } from './cutting-client-group.model';
import { MatBaseGroupDiscount } from './mat-base-group-discount.model';

export enum CuttingClientType {
  PhysicalPerson,
  JuridicalPerson,
}

export class CuttingClient {
  id: number;
  email: string;
  companyName: string;
  surname: string;
  name: string;
  patronymic: string;
  type: CuttingClientType = CuttingClientType.PhysicalPerson;
  INN: string;
  password: string;
  dateCreation: Date;
  phone: string;
  languageCode: string;
  locked: boolean;
  uid1C: string;
  remark: string;
  activated: boolean;
  emailVerified: boolean;
  emailError: string;
  group: CuttingClientGroup;
  personalManagerFullName: string;
  personalManagerId: number;
  defaultDeliveryAddress: ExtendedAddress;
  lastActivityDate?: Date;
  seriesDocument: string;
  numberDocument: string;
  dateOfIssueDocument?: Date;
  presetSettingsId?: number;

  constructor(client?: CuttingClient | any) {
    client = client || {};
    this.id = client.id || 0;
    this.email = client.email || '';
    this.companyName = client.companyName || '';
    this.surname = client.surname || '';
    this.name = client.name || '';
    this.patronymic = client.patronymic || '';
    this.type = client.type || CuttingClientType.PhysicalPerson;
    this.INN = client.INN || '';
    this.password = client.password || '';
    this.phone = client.phone || '';
    this.locked = client.locked || false;
    this.languageCode = client.languageCode || 'en';
    this.dateCreation = client.dateCreation || new Date();
    this.uid1C = client.uid1C || '';
    this.remark = client.remark || '';
    this.activated = client.activated || true;
    this.emailVerified = client.emailVerified || false;
    this.emailError = client.emailError || '';
    this.group = client.group || undefined;
    this.defaultDeliveryAddress = client.defaultDeliveryAddress || undefined;
    this.lastActivityDate = client.lastActivityDate || undefined;
    this.seriesDocument = client.seriesDocument || '';
    this.numberDocument = client.numberDocument || '';
    this.dateOfIssueDocument = client.dateOfIssueDocument || undefined;
    this.presetSettingsId = client.presetSettingsId || null;
  }
}

export class CuttingClientOptions {
  showMaterialTextres = true;
  canDownloadCuttingMaps = false;
  editPanelPosition = false;
  panelTableFields: PanelTableField[] = [];
  showCuttingMaps: boolean | null = null;
  showCuttedMaterialStatistic: boolean | null = null;
  csvSchemaId = 0;
  personalCuttingSettings = '';
  personalCutSettings: IPersonalCuttingSettings = null;
  personalDiscount: PersonalDiscount;
  checkPanelConstrainsFromModels: boolean | null = null;
  readFurnitureFromModels: boolean | null = null;
  readAssemblyFromModels: boolean | null = null;
  orderTableFields: OrderListTableField[];
}

export interface IPersonalCuttingSettings {
  fileSize: number;
  type: CuttingEngine;
  originalName: string;
  date: string;
  fileName: string;
}

export class PersonalDiscount {
  enable = false;
  materials: MatBaseGroupDiscount[] = [];
  operations: MatBaseGroupDiscount[] = [];
}

export interface PanelTableField {
  visible: boolean;
  displayName: string;
  name: string;
  description: string;
}

export class PanelCsvFilelds {
  position = 0;
  name = 1;
  length = 2;
  width = 3;
  count = 4;
  noOrientation = 5;
  thicknessL1 = 6;
  thicknessL2 = 7;
  thicknessW1 = 8;
  thicknessW2 = 9;
}

export enum ImportCsvSaveModeEnum {
  CompleteAll,
  OnlyNew,
  ReplaceExisting,
}
